<template>
	<div class="calculator" :class="{ 'calculator--summary': showSummary }">
		<div v-if="!showSummary" class="calculator__wrapper">
			<Configurator v-if="showConfigurator" />
			<Customizer v-if="showCustomizer" />

			<input
				ref="summary"
				name="calculator"
				type="hidden"
				:value="summary"
				:data-form-validation="`calculator`"
				:data-form-validation-message="$t('validationError')"
				:data-form-error="`#calculator-error`"
			/>
			<input ref="contacts" name="calculatorcontacts" type="hidden" :value="contacts" />
		</div>
		<div v-else class="calculator__summary">
			<Graph v-if="summaryViewShares.length" :shares="summaryViewShares" />
		</div>
	</div>
</template>

<script>
import debounce from 'lodash/debounce';
import Configurator from '../components/Configurator.vue';
import Graph from '../components/Graph.vue';
import Customizer from '../components/Customizer.vue';
import { VIEWS } from '../../config';
import { flatten } from '../utils/helpers';

export default {
	name: 'Calculator',
	components: {
		Configurator,
		Graph,
		Customizer
	},
	computed: {
		summaryViewShares() {
			const shares = this.$store.state.shares.filter(
				share => !['free', 'government'].includes(share.key)
			);

			return shares;
		},
		summary() {
			const summary = {};
			const configurator = this.$store.state.configurator;

			// Fill if configurator was used
			// TODO: Clean up to reduce data
			if (configurator.find(item => item.isChecked !== undefined)) {
				summary.shares = this.$store.state.shares;
				summary.configurator = configurator;
			}

			const value = JSON.stringify(summary);

			return value;
		},
		contacts() {
			const contacts = flatten(this.$store.state.shares)
				.filter(share => !['free', 'government'].includes(share.key))
				.filter(share => !(!share.isAbsolute && share.value === 0))
				.map(share => {
					// Add leveled title
					const title = `${share.title}${
						share.leveledTitle && share.leveledTitle !== share.title
							? ` (${share.leveledTitle})`
							: ''
					}`;

					return {
						key: share.key,
						title
					};
				});
			const value = JSON.stringify(contacts);

			return value;
		},
		showConfigurator() {
			const showConfigurator = this.$store.state.view === VIEWS.CONFIGURATOR;

			return showConfigurator;
		},
		showCustomizer() {
			const showCustomizer = this.$store.state.view === VIEWS.CUSTOMIZER;

			return showCustomizer;
		},
		showSummary() {
			const showSummary = this.$store.state.view === VIEWS.SUMMARY;

			return showSummary;
		}
	},
	watch: {
		summary() {
			this.dispatchSummaryChange();
		},
		contacts() {
			this.dispatchContactsChange();
		}
	},
	methods: {
		dispatchSummaryChange: debounce(function () {
			this.dispatchChange(this.$refs.summary);
		}, 250),
		dispatchContactsChange: debounce(function () {
			this.dispatchChange(this.$refs.contacts);
		}, 250),
		dispatchChange: function (input) {
			if (input) {
				this.$nextTick(() => {
					input.dispatchEvent(new Event('change'));
				});
			}
		}
	}
};
</script>

<style>
@import url('../assets/css/variables.css');

.calculator {
	background: linear-gradient(to bottom, var(--color-background-bright), var(--color-background));
}
.calculator--summary {
	background: transparent;
}
.calculator--summary .calculator__graph-circle--overlay {
	fill: white;
}

/* Desktop */
@media (min-width: 64rem) {
}

/* Transition */
.is-expanding-enter-active,
.is-expanding-leave-active {
	transition: all ease-in-out 0.25s;
	box-sizing: border-box;
}

.is-expanding-enter-from,
.is-expanding-leave-to {
	opacity: 0;
}
.is-expanding-enter-from.is-expanding-enter-from,
.is-expanding-leave-to.is-expanding-leave-to {
	padding-top: 0;
	padding-bottom: 0;
	margin-top: 0;
}
</style>
